module.exports = __webpack_public_path__ + "img/Telescopium.bd0e6c62.png";